import constant from "../../../constants/constant";
const regionCode:boolean = Number(localStorage.getItem("store_region")) === constant.STORE_REGION.KUWAIT ;

export const validationRulesSubAdmin: any = {
  username: {
    required: true,
  },
  mobile: {
    required: true,
    requiredLength: regionCode ? constant.KUWAIT_NUMBER_LENGTH : constant.INDIA_NUMBER_LENGTH,
  },
  email: {
    required: true,
    pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  },
  login_id:{
    required: true,
    // pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@#])[a-zA-Z\d@#]+$/,
  }
  // role: {
  //   label: { required: true },
  // },
}
